module.exports = __webpack_public_path__ + "img/5stars.f39e8640.jpg";